import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { AskADoctorOptionCardComponent } from '../ask-a-doctor-option-card/ask-a-doctor-option-card.component';
import { CommonModule } from '@angular/common';
import { environment } from '../../../../../environments/environment';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { getLocaleFromUrl } from '../../../../shared/services/translate/locale-utils';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MonitoringService } from '../../../../shared/services/monitoring/monitoring-service';


@Component({
  selector: 'app-ask-a-doctor',
  imports: [CommonModule, TranslateModule, MatProgressSpinnerModule, MatCardModule, MatButtonModule, AskADoctorOptionCardComponent],
  templateUrl: './ask-a-doctor.component.html',
  styleUrl: './ask-a-doctor.component.css'
})
export class AskADoctorComponent {

  @Input() locale: string | null = null;
  @Input() quickCareOptions: Array<any> = [];

  public title: string = 'TITLE';
  public description: string = 'DESCRIPTION';
  public showMoreText: string = 'SHOW_MORE';  

  constructor(private translate: TranslateService, private monitoringService: MonitoringService) {
    // Set the default language for translations
    this.translate.setDefaultLang('en-US');
    const language = getLocaleFromUrl();
    this.translate.use(language);
  }

  ngOnInit(): void {
   this.translate.get('QUICKCARE.TITLE').subscribe((translated: string) => {
      this.title = translated;
    });

    this.translate.get('QUICKCARE.DESCRIPTION').subscribe((translated: string) => {
      this.description = translated;
    });

    this.translate.get('SHOW_MORE').subscribe((translated: string) => {
      this.showMoreText = translated;
    });
  }


  showMeMore() {
    const eptID = sessionStorage.getItem("eptID");

    if (eptID == null || eptID == undefined || eptID == "") {
      this.showMeMoreUnAuth();
    }
    else {
      this.showMeMoreAuth();
    }
  }

  showMeMoreUnAuth() {
    var deepLink = environment.web_quickcare_unauth_deep_link_base_url; // For web users, use the web deep link

    deepLink += this.locale == 'es-US' ? '?l=es' : '?l=en'; // Append language parameter

    console.log("Show me more clicked");
    console.log(deepLink);

    this.monitoringService.logEvent('ShowMore/NoAuth', { feature: 'get-care-now', subfeature: 'QuickCare', platform: 'web' }); // log as web event
    window.location.href = deepLink;
  }

  showMeMoreAuth() {
    var deepLink = environment.web_quickcare_deep_link_base_url; // For web users, use the web deep link

    console.log("Show me more clicked");
    console.log(deepLink);

    this.monitoringService.logEvent('ShowMore', { feature: 'get-care-now', subfeature: 'QuickCare', platform: 'web' }); // log as web event

    window.location.href = deepLink;

  }

}
